module.exports = __webpack_public_path__ + "static/img/7050_phase_function_Paper_PointsHejduk_Prediction.24bdcb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7050_phase_function_Paper_PointsHejduk_Prediction.png
// module id = g6KB
// module chunks = 0